<template>
  <div v-if="!loading">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition du rendez-vous</span>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <router-link :to="{name: 'CalendarMonthView'}" class="page-header-btn is-small">
          <span class="icon"><i class="fal fa-calendar-alt"></i></span>
          <span>{{today | prettyDate}}</span>
        </router-link>
      </div>
      <google-sync-button slot="left-action"></google-sync-button>
    </sticky>
    <div class="columns is-gapless is-padding-left-on-btn-actions is-padding-right-on-btn-actions is-padding-top">
      <div class="column is-8 is-9-widescreen is-padding-right">
        <div class="has-bg-white is-border">
          <calendar-form @submit="val => submit(val, null)"
                         @cancel="cancel"
                         @newEvent="(val, sync) => submit(val, sync)"
                         :source="rdv"
                         :confirmed-rdv="confirmedRdv"
                         :loading="loading"
                         :sync-loading="syncLoading"
                         :is-exported="isExported"
                         v-if="rdv && rdv.pk"
          ></calendar-form>
        </div>
      </div>
      <div class="column is-4 is-3-widescreen">
        <div class="is-border">
          <div class="columns is-column is-border-bottom">
            <div class="column has-bg-light-darken-1 columns is-vcentered is-gapless">
              <div class="column is-narrow">
                <span class="icon is-large has-text-grey"><i class="fal fa-info-circle fa-3x">&nbsp;</i></span></div>
              <div class="column"><span class="title is-4">&nbsp;<b>Information</b></span></div>
            </div>
            <div class="column has-text-grey" v-if="tab === 'rdv'">
              <p>1.Sélectionnez le numéro de rendez-vous. (ex: R0 pour un premier contact téléphonique, R1 pour un
                premier rendez-vous physique, etc.)</p>
              <p class="is-margin-top-small">2.Optionnel : Vous avez la possibilité d’associer un vendeur au rendez-vous
                en décochant le bouton ‘Ce rdv est pour moi’.</p>
              <p class="is-margin-top-small">3.Sélectionnez le contact avec lequel vous souhaitez enregistrer le
                rendez-vous.</p>
              <p class="is-margin-top-small">4.Choisissez la date et l’heure de votre rendez-vous ainsi que sa
                durée.</p>
              <p class="is-margin-top-small">5.Vous avez la possibilité d’entrer un lieu / une adresse pour ce
                rendez-vous, vous permettant de voir où il se situe directement depuis l’espace de gestion des
                rendez-vous.</p>
              <p class="is-margin-top-small">6.Validez votre rendez-vous pour le créer. Un mail de confirmation du
                rendez-vous sera automatiquement envoyé aux utilisateurs concernés.</p>
            </div>
            <div class="column has-text-grey" v-if="tab === 'confirm'">
              <p><b>Vous pouvez exporter vos rendez-vous pour les retrouver sur vos agendas préférés. </b></p>
              <p class="is-margin-top-small">Passez par l'exportation vers l'agenda Google pour retrouver vos
                rendez-vous dans votre Google Agenda (vous devrez vous connecter pour effectuer cette action)</p>
              <p class="is-margin-top-small">Passez par l'exportation vers un autre agenda pour télécharger l'événement
                sur votre ordinateur (en .ics)</p>
            </div>
            <!-- <div class="column is-border-top">
              <p><a class="has-text-grey has-text-weight-medium" >Lien Guide d'utilisation</a></p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <spinner-round :isLoading="loading" v-else></spinner-round>
</template>

<script>
  import CalendarForm from './CalendarForm'
  import GoogleSyncButton from './GoogleSyncButton'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { isNil } from 'lodash'
  import { rdvToGoogleEvent } from '../../utils'

  export default {
    name: 'CalendarEdit',
    components: {CalendarForm, GoogleSyncButton},
    data () {
      return {
        loading: true,
        rdv: {},
        id: this.$route.params.id,
        tab: 'rdv',
        today: new Date(),
        confirmedRdv: null,
        syncLoading: false
      }
    },
    computed: {
      ...mapGetters(['currentUserPk']),
      isRdvSeller () {
        return this.rdv.seller === this.currentUserPk
      },
      isExported () {
        return isNil(this.rdv.google_event_id) === false && isNil(this.rdv.google_calendar_id) === false
      }
    },
    methods: {
      getRdv (silent = false) {
        this.loading = true
        this.$api.rdvService.getOne(this.id).then(r => {
          this.loading = false
          this.rdv = r.data
        }).catch(() => {
          this.loading = false
        })
      },
      async submit (newRdv, sync = false) {
        if (!sync) {
          this.loading = true
          this.$set(this, 'tab', 'confirm')
        } else {
          this.syncLoading = true
        }
        let success = false
        try {
          let request = await this.$api.rdvService.put(this.id, newRdv)
          this.loading = false
          this.syncLoading = false
          this.rdv = request.data
          if (!sync) this.confirmedRdv = request.data
          let key = moment(this.rdv.date).format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', {event: this.rdv, key, type: 'rdvs'})
          success = true
        } catch (e) {
          this.loading = false
          this.syncLoading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'édition du rendez-vous'
          })
        }

        if (success && this.isExported && !sync) {
          this.$notify({
            type: 'is-success',
            text: 'Rdv modifié.'
          })
          this.updateGoogleRdv(this.rdv)
        } else if (success && this.isExported && sync) {
          this.getRdv()
        }
      },
      updateGoogleRdv (rdv) {
        let event = rdvToGoogleEvent(rdv, this.$configs.APPHOST)
        let request = window.gapi.client.calendar.events.patch({
          eventId: rdv.google_event_id,
          calendarId: rdv.google_calendar_id,
          resource: event
        })
        delete event.source
        request.execute((e) => {
          if ('code' in e && e.code === 400) {
            console.log(e)
            console.log('error google sync')
          }
        })
      },
      cancel () {
        this.$router.goBack(this.$route)
        // this.$router.push({name: 'CalendarMonthView'})
      }
    },
    created () {
      this.getRdv()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarEdit.vue